<template>
    <div class="container">
          <div 
      v-for="(item, index) in items" 
      :key="index" 
      :class="['box', item.isSpecial ? 'item1' : 'item']"
      @click="handleBoxClick(item.content)"
    >
      {{ item.content }}
    </div>
    </div>
</template>
<script>
export default{
     name: 'ContainerBox',
  props: {
    items: {
      type: Array,
      required: true,
      validator: value => {
        return value.every(item => 
          typeof item === 'object' && 
          'content' in item && 
          'isSpecial' in item
        )
      }
    }
  },
    data(){
        return{

        }
    },
    methods:{
    handleBoxClick(content) {
      console.log('点击了盒子:', content)
      // 同时触发父组件的事件
      this.$emit('box-click', content)
    }
    }
}
</script>
<style scoped>
.box {
  width: calc((100% - 6 * 10px) / 7);
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: white;
  font-family: Arial;
}
.container {
  width: 450px;
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 10px; /* 盒子之间的间距 */

  padding: 10px;
}

.item {
  width: calc((100% - 6 * 10px) / 7);
  height: 50px; /* 固定高度 */
  background: rgba(237, 244, 251, 1);
  color: rgba(67, 67, 67, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
border: 1px solid rgba(130, 145, 169, 1);


}
.item1 {
  width: calc((100% - 6 * 10px) / 7);
  height: 50px; /* 固定高度 */
  background: rgba(247, 69, 69, 1);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid rgba(130, 145, 169, 1);
}
.box:hover {
  transform: scale(1.05); /* 悬停效果 */
  cursor: pointer;
}

.box:active {
  transform: scale(0.98); /* 点击效果 */
  cursor: pointer;
}
</style>